<template>
    <div>
        <div class="holder full flex wrap center vcenter">
            <Tabs :meta="{
                key: 'channel',
                type: 'category',
                name: 'نوع ارسال',
                extras: 'R0:key=multiple,value=چندگانه;R1:key=internal,value=داخلی;R2:key=external,value=خارجی'
            }" :vm="models['channel']" @onchange="(obj) => models[obj.key] = obj.value"></Tabs>
        </div>
        <div v-show="models['channel'] === 'multiple' || models['channel'] === 'internal'"
            class="holder full flex wrap center vcenter">
            <Tabs :meta="{
                key: 'type',
                type: 'tab',
                name: 'نوع گیرنده',
                extras: 'R0:key=data,value=parents_type'
            }" :vm="models['type']" @onchange="(obj) => models[obj.key] = obj.value"></Tabs>
        </div>
        <div v-show="models['channel'] === 'multiple' || models['channel'] === 'internal'" class="search">
            <MetaBox :meta="{
                key: 'search',
                type: 'text',
                name: 'جست و جو'
            }" :vm="models['search']" @onchange="(obj) => models[obj.key] = obj.value"></MetaBox>
        </div>
    </div>
    <div v-show="models['channel'] === 'multiple' || models['channel'] === 'internal'" class="recipients">
        <div v-show="recipients()?.length > 0" class="all flex wrap center vcenter">
            <Checkbox @onclick="() => {
                if (selected.length === recipients()?.length)
                    selected = []
                else
                    selected = recipients()?.map(entity => entity.uid)
            }" :vm="selected.length === recipients()?.length && recipients()?.length > 0"></Checkbox>
            <div class="profile">
            </div>
            <div class="information">
            </div>
        </div>
        <template v-for="(entity, index) in recipients()" :key="index">
            <div class="flex wrap center vcenter">
                <Checkbox @onclick="() => {
                    if (selected.includes(entity?.uid))
                        selected = selected.filter((item) => { return item !== entity.uid })
                    else
                        selected.push(entity?.uid)
                }" :vm="selected.includes(entity?.uid)"></Checkbox>
                <div class=" profile">
                    <img v-lazy="'/images/profile.webp'" alt="نمایه کاربری" loading="lazy" />
                </div>
                <div class="information">
                    <h1 v-if="entity.uid.toLowerCase().startsWith('e472')">نام و نام خانوادگی: {{ entity.name }}</h1>
                    <h1 v-else-if="entity.uid.toLowerCase().startsWith('e231')">عنوان گروه: {{ entity.name }}</h1>
                    <h1 v-else-if="entity.uid.toLowerCase().startsWith('e450')">عنوان نقش: {{ entity.name }}</h1>
                    <p v-if="entity.mobile">شماره همراه: {{ entity.mobile }}</p>
                    <p v-if="entity.email">ایمیل: {{ entity.email }}</p>
                </div>
            </div>
        </template>
    </div>
    <div v-show="models['channel'] === 'multiple' || models['channel'] === 'external'" class="external"
        :class="{ 'single': recipients()?.length === 0 || models['channel'] === 'external' }">
        <MetaBox :meta="{
            key: 'external',
            type: 'textarea',
            name: 'گیرندگان خارجی'
        }" :vm="models['external']" @onchange="(obj) => models[obj.key] = obj.value"></MetaBox>
    </div>
    <div class="option flex wrap center vcenter">
        <Option :color="'green'" :icon="'fe-refresh-cw'" :name="'بروزرسانی لیست'" @onclick="onclick"></Option>
    </div>
</template>

<script>
/* eslint-disable */
import Tabs from '../Form/Inputs/Tabs.vue'
import MetaBox from '../Form/Inputs/MetaBox.vue'
import Checkbox from '../Form/Inputs/Checkbox.vue'
import Option from '../Form/Option.vue'

export default {
    name: 'Parents',
    props: ['data'],
    inject: ['base'],
    components: { Tabs, MetaBox, Checkbox, Option },
    computed: {
        vm() {
            return this.data?.vm
        },
        search() {
            return this.models?.search
        }
    },
    created() {
    },
    data() {
        return {
            entities: [],
            models: { type: 'ALL', channel: 'multiple' },
            selected: [],
            externals: [],
            timer: null
        }
    },
    watch: {
        vm(newVM, oldVM) {
            this.selected = []
            this.models['external'] = ''
            this.data?.vm?.forEach(element => {
                if (new RegExp(/^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/).test(element))
                    this.selected.push(element)
                else
                    this.models['external'] = `${this.models['external'] || ''}${element}\n`
            })
        },
        models: {
            handler(newModels, oldModels) {
                this.externals = this.models['external']?.split('\n') || []
            },
            deep: true
        },
        search(newSearch, oldSearch) {
            if (this.base.Util().validate(this.models['search']) && this.models['search'].length > 3) {
                clearTimeout(this.timer)
                this.timer = setTimeout(() => {
                    this.base.API().get(`Procedures/Recipient/Recipients?query=${this.models['search']}`, (response) => {
                        if (this.base.Util().success(response))
                            if (this.base.Util().validate(response.data.data))
                                this.entities = response.data.data
                    })
                }, 1250)
            }
        },
        externals: {
            handler(newExternals, oldExternals) {
                this.externals = this.externals.filter((element) => element !== '')
            },
            deep: true
        }
    },
    methods: {
        recipients() {
            return this.entities?.filter((entity) => {
                return ((entity.name.includes(this.models['search'])
                    || entity.mobile?.includes(this.models['search'])
                    || entity.email?.includes(this.models['search']))
                    && this.base.Util().validate(this.models['search']) && this.models['search'].length > 3) &&
                    ((entity.uid.toLowerCase().startsWith('e472') && this.models['type'] === 'ACCOUNT')
                        || (entity.uid.toLowerCase().startsWith('e231') && this.models['type'] === 'GROUP')
                        || (entity.uid.toLowerCase().startsWith('e450') && this.models['type'] === 'ROLE')
                        || this.models['type'] === 'ALL')
            })
        },
        onclick() {
            let recipients = []
            if (this.models['channel'] === 'multiple')
                recipients = recipients.concat(this.selected).concat(this.externals || [])
            else if (this.models['channel'] === 'internal')
                recipients = recipients.concat(this.selected)
            else if (this.models['channel'] === 'external')
                recipients = recipients.concat(this.externals)
            this.$emit('onresult', recipients)
        }
    }
}
</script>

<style src="../../assets/css/components/dialogs/parents.css"></style>
<style src="../../assets/css/components/dialogs/parents_dark.css"></style>